<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="400px"
      transition="dialog-transition"
    >
      <v-sheet>
        <v-toolbar dark class="primary">
          <v-btn
            icon
            @click="onClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Datos del cliente</v-toolbar-title>
        </v-toolbar>
        <v-form
          ref="form"
          v-model="valid"      
        >
          <v-container>
            <v-text-field
              v-model="documento"
              placeholder="Ingrese un número de documento"
              label="Número de documento"
              :rules="rules.documento"
              prepend-icon="mdi-card-account-details"
              color="primary"
              append-icon="mdi-magnify"
              :loading="searching"
              @click:append="buscarCliente"
              @keydown.enter.prevent="buscarCliente"
            ></v-text-field>
            <v-text-field
              v-model="razonSocial"
              placeholder="Ingrese apellido y nombre"
              label="Apellido y nombre"
              :rules="rules.razon_social"
              prepend-icon="mdi-text-short"
              color="primary"
              append-icon="mdi-magnify"
              :loading="searching"
              @click:append="buscarClientePorNombre"
              @keydown.enter.prevent="buscarClientePorNombre"
            ></v-text-field>
            <v-subheader>Datos de cuenta</v-subheader>
            <v-text-field
              v-model="numero"
              placeholder="Numero de cuenta"
              label="Numero"
              :rules="rules.numero"
              prepend-icon="mdi-credit-card"
              color="primary"
            ></v-text-field>
            <v-text-field
              v-model="descripcion"
              placeholder="Descripcion para la cuenta"
              label="Descripcion"
              :rules="rules.descripcion"
              prepend-icon="mdi-text-short"
              color="primary"
            ></v-text-field>
            <v-footer>
              <v-btn
                :disabled="!updatable && !$can('clientes.store')"
                color="primary"
                @click="onSubmit"
                :loading="loading"
              >
                Registrar
              </v-btn>
            </v-footer>
          </v-container>
        </v-form>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'ClienteCreateComponent',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: Boolean
  },
  data () {
    return {
      valid: false,
      searching: false,
    }
  },
  beforeDestroy () {
    this.onClearEdited()
    this.onClearSelected()
  },
  created () {
    //
  },
  computed: {
    ...mapGetters('Clientes', ['edited', 'rules', 'loading', 'updatable']),
    id () {
      return this.edited.id
    },
    dialog: {
      get () {
        return this.selected
      },
      set (value) {
        this.$emit('change', value)
      }
    },
    documento: {
      get () {
        return this.edited.documento
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          documento: value
        })
      }
    },
    razonSocial: {
      get () {
        return this.edited.razon_social
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          razon_social: value
        })
      }
    },
    numero: {
      get () {
        return this.edited.numero
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          numero: value
        })
      }
    },
    descripcion: {
      get () {
        return this.edited.descripcion
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          descripcion: value
        })
      }
    },
  },
  methods: {
    ...mapActions('Clientes', ['onSave', 'onClearEdited', 'onClearSelected']),
    ...mapMutations('Clientes', ['setEdited']),
    async buscarCliente() {
      if (!this.documento) {
        this.$store.commit('ResponseHTTP/addError', 'Debe ingresar un número de documento para buscar', { root: true });
        return;
      }
      this.searching = true;
      try {
        const response = await axios.get('/clientes', {
          params: {
            documento: this.documento
          }
        });
        const clientes = response.data.data;
        let client = clientes.find(c => String(c.documento).trim() === String(this.documento).trim());
        if (!client && clientes.length > 0) {
          client = clientes[0];
        }
        if (client) {
          this.setEdited({
            ...this.edited,
            id: client.id,
            documento: client.documento,
            razon_social: client.razon_social,
          });
          this.$store.commit('ResponseHTTP/addSuccess', 'Cliente encontrado y autocompletado', { root: true });
        } else {
          this.setEdited({
            ...this.edited,
            id: null,
            razon_social: '',
          });
          this.$store.commit('ResponseHTTP/addSuccess', 'Cliente no registrado. Ingrese los datos para un cliente nuevo', { root: true });
        }
      } catch (error) {
        console.error(error);
        this.$store.commit('ResponseHTTP/addError', 'Error al buscar el cliente', { root: true });
      } finally {
        this.searching = false;
      }
    },
    async buscarClientePorNombre() {
      if (!this.razonSocial) {
        this.$store.commit('ResponseHTTP/addError', 'Debe ingresar un nombre para buscar', { root: true });
        return;
      }
      this.searching = true;
      try {
        const response = await axios.get('/clientes', {
          params: {
            razon_social: this.razonSocial
          }
        });
        const clientes = response.data.data;
        let client = clientes.find(c => String(c.razon_social).toLowerCase().trim() === String(this.razonSocial).toLowerCase().trim());
        if (!client && clientes.length > 0) {
          client = clientes[0];
        }
        if (client) {
          this.setEdited({
            ...this.edited,
            id: client.id,
            documento: client.documento,
            razon_social: client.razon_social,
          });
          this.$store.commit('ResponseHTTP/addSuccess', 'Cliente encontrado y autocompletado', { root: true });
        } else {
          this.setEdited({
            ...this.edited,
            id: null,
            documento: '',
          });
          this.$store.commit('ResponseHTTP/addSuccess', 'Cliente no registrado. Ingrese los datos para un cliente nuevo', { root: true });
        }
      } catch (error) {
        console.error(error);
        this.$store.commit('ResponseHTTP/addError', 'Error al buscar el cliente', { root: true });
      } finally {
        this.searching = false;
      }
    },
    onSubmit () {
      this.$refs.form.validate()
      if (this.valid) {
        this.onSave().then(response => {
          this.$emit('created', response.data);
          this.dialog = false
        })
      }
    },
    onClose (event) {
      event.preventDefault()
      this.dialog = false
    }
  },
}
</script>
